// The templates endpoint returns only a slug — labels live here until the backend serves them.
const templateLabels = {
  BusinessTripStaffFinalReport: "Документи за командировки – служител",
  BusinessTripJuryFinalReport: "Документи за командировки – жури",
  BusinessTripStudentFinalReport: "Документи за командировки – студент",
  ParticipationFeeReportTemplate: "Доклад за такса участие",
};

// Falls back to the raw key so a template added on the backend still renders.
export const templateLabel = key => templateLabels[key] ?? key;
